import { style } from "@vanilla-extract/css";

import { theme } from "@huub-web/ui/theme/css/theme.css";
import { recipe } from "@vanilla-extract/recipes";
import { responsiveContainer } from "@huub-web/ui/utils/responsive";

export const containerStyle = recipe({
  base: {},
  variants: {
    hasImage: {
      true: {},
      false: {
        // aspectRatio: "auto !important",
      },
    },
  },
});

export const headerStyle = recipe({
  base: {
    padding: theme.spacings.xs,
  },
  variants: {
    hasImage: {
      true: {},
      false: {},
    },
  },
});

export const contentStyle = recipe({
  variants: {
    hasImage: {
      true: {},
      false: {},
    },
  },
});

export const shadowStyle = style({
  textShadow: `0 0 20px rgba(0, 0, 0, 0.05)`,
});

export const headerContainerStyle = style({
  flexDirection: "column",
  gap: theme.spacings.xs,
  ...responsiveContainer({
    600: {
      flexDirection: "row",
      gap: theme.spacings.s,
    },
  }),
});
